import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, post, put } from "helpers/api_helper"
import {
  GET_ROLES_LISTS,
  GET_ALL_ROLES_LISTS,
  DELETE_ROLE,
  GET_PERMISSIONS,
  CREATE_ROLE,
  GET_SINGLE_ROLE,
  UPDATE_ROLE,
  GET_ASSIGNED_ROLE_DATA,
  GET_CANDIATE_ROLE_DATA,
} from "helpers/url_helper"

export const getRolesLists = createAsyncThunk(GET_ROLES_LISTS, async () => {
  const response = await get(GET_ROLES_LISTS)
  return response
})

export const getAllRolesLists = createAsyncThunk(
  GET_ALL_ROLES_LISTS,
  async payload => {
    const response = await post(GET_ALL_ROLES_LISTS, payload)
    return response
  }
)

export const deleteRole = createAsyncThunk(DELETE_ROLE, async id => {
  const response = await del(`${DELETE_ROLE}/${id}`)
  return response
})

export const getPermissions = createAsyncThunk(GET_PERMISSIONS, async () => {
  const response = await get(GET_PERMISSIONS)
  return response
})

export const createRole = createAsyncThunk(CREATE_ROLE, async payload => {
  const response = await post(CREATE_ROLE, payload)
  return response
})

export const getSingleRole = createAsyncThunk(
  GET_SINGLE_ROLE + "role",
  async payload => {
    const response = await get(`${GET_SINGLE_ROLE}/${payload}`)
    return response
  }
)
export const updateRole = createAsyncThunk(
  UPDATE_ROLE + "role",
  async payload => {
    const response = await put(`${UPDATE_ROLE}/${payload.id}`, payload.data)
    return response
  }
)

export const getUserRoleAndPermissions = createAsyncThunk(
  GET_ASSIGNED_ROLE_DATA,
  async () => {
    const response = await get(GET_ASSIGNED_ROLE_DATA)
    return response
  }
)
export const getCandiateRoleData = createAsyncThunk(
  GET_CANDIATE_ROLE_DATA,
  async () => {
    const response = await get(GET_CANDIATE_ROLE_DATA)
    return response
  }
)
